import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { SButton, SButtonIcon, SButtonContents, SSpinner, SButtonLink } from './Button.styles.js';

const Button = /*#__PURE__*/ React.forwardRef(({ children, isLoading, leadingIcon, prominence = "high", scale = "medium", trailingIcon, ...restProps }, ref)=>{
    return jsxs(SButton, {
        ref: ref,
        as: "button",
        prominence: prominence,
        scale: scale,
        type: "button",
        ...restProps,
        disabled: isLoading || restProps.disabled,
        children: [
            leadingIcon ? jsx(SButtonIcon, {
                isLoading: isLoading,
                scale: scale,
                children: leadingIcon instanceof Function ? leadingIcon({}) : leadingIcon
            }) : null,
            children ? jsx(SButtonContents, {
                isLoading: isLoading,
                scale: scale,
                children: children
            }) : null,
            trailingIcon ? jsx(SButtonIcon, {
                isLoading: isLoading,
                scale: scale,
                children: trailingIcon instanceof Function ? trailingIcon({}) : trailingIcon
            }) : null,
            isLoading ? jsx(SSpinner, {}) : null
        ]
    });
});
const ButtonLink = /*#__PURE__*/ React.forwardRef(({ children, leadingIcon, prominence, scale, trailingIcon, ...restProps }, ref)=>{
    return jsxs(SButtonLink, {
        ref: ref,
        as: "a",
        prominence: prominence,
        scale: scale,
        ...restProps,
        children: [
            leadingIcon ? jsx(SButtonIcon, {
                scale: scale,
                children: leadingIcon instanceof Function ? leadingIcon({}) : leadingIcon
            }) : null,
            children ? jsx(SButtonContents, {
                scale: scale,
                children: children
            }) : null,
            trailingIcon ? jsx(SButtonIcon, {
                scale: scale,
                children: trailingIcon instanceof Function ? trailingIcon({}) : trailingIcon
            }) : null
        ]
    });
});

export { Button, ButtonLink };
